import React, { useState, useEffect } from 'react';
import { getEnum, createEnum, deleteEnum } from '../../api';
import { useNotification } from '../../context/NotificationContext';

const EnumTable = ({ enumType, title }) => {
  const [items, setItems] = useState([]);
  const [newItemName, setNewItemName] = useState('');
  const [newItemDesc, setNewItemDesc] = useState('');
  const [showForm, setShowForm] = useState(false);
  const { showNotification } = useNotification();

  const fetchItems = async () => {
    try {
      const data = await getEnum(enumType);
      setItems(data);
    } catch (error) {
      console.error(`Error fetching ${enumType}:`, error);
    }
  };

  useEffect(() => {
    fetchItems();
  }, [enumType]);

  const handleAddItem = async (e) => {
    e.preventDefault();
    try {
      await createEnum(enumType, { name: newItemName, description: newItemDesc });
      setNewItemName('');
      setNewItemDesc('');
      setShowForm(false);
      fetchItems();
      showNotification('Item added successfully!', 'success');
    } catch (error) {
      showNotification(`Error adding item: ${error.message}`, 'error');
      console.error(`Error adding ${enumType}:`, error);
    }
  };

  const handleDeleteItem = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await deleteEnum(enumType, id);
        fetchItems();
        showNotification('Item deleted successfully!', 'success');
      } catch (error) {
        showNotification(`Error deleting item: ${error.message}`, 'error');
        console.error(`Error deleting ${enumType}:`, error);
      }
    }
  };

  return (
    <div className="card mb-6">
      <div className="card-header">
        <h4 className="text-xl font-semibold text-purple-600">{title}</h4>
      </div>
      <div className="p-4">
        <div className="table-container">
          <table className="enum-table w-full">
            <thead>
              <tr>
                <th className="px-4 py-2">Name</th>
                <th className="px-4 py-2">Description</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id}>
                  <td className="border px-4 py-2">{item.name}</td>
                  <td className="border px-4 py-2">{item.description}</td>
                  <td className="border px-4 py-2 text-center">
                    <button onClick={() => handleDeleteItem(item.id)} className="remove-button">
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-4 flex justify-center">
          <button onClick={() => setShowForm(!showForm)} className="add-new-btn">
            {showForm ? 'Cancel' : 'Add New'}
          </button>
        </div>
        {showForm && (
          <form onSubmit={handleAddItem} className="add-form">
            <input
              type="text"
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              placeholder="Name"
              className="form-input"
              required
            />
            <textarea
              value={newItemDesc}
              onChange={(e) => setNewItemDesc(e.target.value)}
              placeholder="Description"
              className="form-input mt-2"
            ></textarea>
            <button type="submit" className="submit-button mt-2">
              Add
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default EnumTable; 